import ProfilesIcon from '../../../assets/icons/profiles.svg?react';
import BedIcon from '../../../assets/icons/bed.svg?react';
import { Tag } from '../../UI';
import { evaluateKpiSeverity } from './kpiSeverity';
import { OverbookingPopover } from './OverbookingPopover';
import type { WeekKpi } from './types';
import styles from './WeekKpiCell.module.css';

interface PatientsBedsRowProps {
  kpi: WeekKpi;
}

export const PatientsBedsRow = ({ kpi }: PatientsBedsRowProps) => {
  // Beds have no WARNING state (no warningMargin on their threshold), so EXCEEDED is
  // the only severity that triggers the red chip — unlike profession hours.
  const hasOverbookings = kpi.bedResources.some(
    (resource) => evaluateKpiSeverity(resource.used, resource.threshold) === 'EXCEEDED',
  );

  return (
    <div className={styles.patientsBedsRow}>
      <Tag
        label={
          <>
            <ProfilesIcon className={styles.counterIcon} aria-hidden="true" />
            {kpi.patientsCount}
          </>
        }
        size="small"
      />
      <Tag
        label={
          <>
            <BedIcon className={styles.counterIcon} aria-hidden="true" />
            {kpi.bedsCount}
          </>
        }
        size="small"
        tooltip={
          hasOverbookings ? <OverbookingPopover bedResources={kpi.bedResources} /> : undefined
        }
        className={hasOverbookings ? styles.tagError : ''}
      />
    </div>
  );
};
